<template>
  <div v-if="suggestionTags.length" class="ai-generate-suggestions">
    <!-- Collapse Toggle -->
    <button
      :key="isExpanded"
      class="ai-suggestion-toggle fs-sa-12 fw-400 text-hint d-flex align-items-center gap-gd-half align-items-center"
      :class="{ collapsed: !isExpanded }"
      :aria-expanded="isExpanded ? 'true' : 'false'"
      aria-controls="ai-suggestion-collapse"
      :disabled="isLoading"
      @click="isExpanded = !isExpanded"
    >
      <span class="fa-sa-12 fw-700 text-makeweb-ai-gradient mr-gd-1">{{ $t('engine.aiGenerate.lblSuggestion', languageEngine) }}</span>
      <i class="fal fs-sa-12 text-black-hydrocarbon align-self-center" :class="isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
    </button>

    <!-- Collapsible Tags -->
    <b-collapse id="ai-suggestion-collapse" v-model="isExpanded">
      <div class="d-flex align-items-center flex-wrap gap-gd-1 pt-gd-1">
        <ChipSelect
          mode="tags"
          option-value="id"
          :options="suggestionTags"
          :value="selectedTagId"
          :disabled="isLoading"
          :option-label-formatter="getTagLabel"
          :isShowLabelAndValue="true"
          @change="handleSuggestionClick"
        />
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChipSelect from '@components_system/Shared/Tools/ChipSelect/ChipSelect.vue';

export default {
  name: 'AIGenerateSuggestions',
  components: {
    ChipSelect
  },
  props: {
    suggestionTags: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    selectedTagId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isExpanded: true
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine'
    })
  },
  methods: {
    getTagLabel(tag) {
      if (tag.labelDirect) return tag.labelDirect;
      return this.$t(tag.label, this.languageEngine);
    },
    handleSuggestionClick(tag) {
      this.$emit('suggestion-click', tag);
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-generate-suggestions {
  width: 100%;
}

.ai-suggestion-toggle {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #53585D;
  }
}
</style>
